import { Map, List, fromJS } from 'immutable';
import { SET_SHIPS } from '../actionTypes';

const initialState = Map({
  retrofitsCount: 0,
  collabsCount: 0,
  list: List(),
});

function getRetrofitsCount(ships) {
  return ships.filter((ship) => ship.retrofit === 'all').length;
}

function getCollabsCount(ships) {
  return ships.filter((ship) => ship.id.toLowerCase().includes('collab'))
    .length;
}

export default function shipsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SHIPS: {
      const { payload } = action;
      return Map({
        retrofitsCount: getRetrofitsCount(payload),
        collabsCount: getCollabsCount(payload),
        list: List(fromJS(payload)),
      });
    }

    default:
      return state;
  }
}
